export default {"src":"/_next/static/media/renewable_energy_24.1780eee8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};